import { getAppEnvironment } from "@/api/authenticate";
import { disconnectZebra, getBluetoothReaders, getDeviceInfo, getZebraConnectionStatus, getTagLocatePercentage, startTagLocate, stopTagLocate, getTagLocateStatus, getInventoryStatus, startInventory, stopInventory, getTagData, getDeviceInfoInstant } from "@/api/rfid";
import Config from "@/config";

let deviceInfoInterval = {
  interval : Config.RFIDReloadIntervals.deviceInfoInterval,
  timer: null
}

let tagLocatePercentageInterval = {
  interval: Config.RFIDReloadIntervals.tagLocatePercentageInterval,
  timer: null
}

let tagInventoryInterval = {
  interval: Config.RFIDReloadIntervals.tagInventoryInterval,
  timer: null
}

const deviceInfoState = {
  isConnected: false,
  selectedReader: -1,
  inventoryState: false,
  readTags: [],
  tagLocateState: false,
  percentageLocate: 0,
  readers: [],
  config: {
    reportConfig: {
      channelIndex: false,
      firstSeenTime: false,
      lastSeenTime: false,
      pc: false,
      phase: false,
      rssi: false,
      tagSeenCount: false
    },
    uniqueTags: false
  },
  deviceInfo: {
    battery: {
      level: -1,
      voltage: -1,
      isCharging: false
    },
    temperature: {
      ambTemp: -1,
      paTemp: -1
    },
    device: {
      modelName: '',
      serialNumber: '',
      manufacturerName: '',
      manufacturerDate: ''
    }
  }
}

let state = Object.assign({}, deviceInfoState);

const mutations = {
  SET_IS_CONNECTED: (state, isConnectedData) => {
    state.isConnected = isConnectedData;
  },
  SET_DEVICE_INFO: (state, deviceInfoData) => {
    state.deviceInfo = deviceInfoData;
  },
  SET_CONFIG: (state, configData) => {
    state.config = configData;
  },
  SET_READERS: (state, readersData) => {
    state.readers = readersData;
  },
  SET_TAGS_READ: (state, tags) => {
    state.readTags = tags;
  },
  SET_PERCENTAGE_LOCATE: (state, percentageData) => {
    state.percentageLocate = percentageData;
  },
  SET_INVENTORY_STATE: (state, inventoryStateData) => {
    state.inventoryState = inventoryStateData;
  },
  SET_TAG_LOCATE_STATE: (state, tagLocateStateData) => {
    state.tagLocateState = tagLocateStateData;
  }
}

const actions = {
  getConnectionStatus({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      getZebraConnectionStatus().then(response => {
        commit('SET_IS_CONNECTED', response)

        resolve(response);

        if(response){
          if(deviceInfoInterval.timer) return null;

          deviceInfoInterval.timer = setInterval(function(){
            dispatch('getDeviceInfo');
          }, deviceInfoInterval.interval);
        } else {
          if(deviceInfoInterval.timer){
            clearInterval(deviceInfoInterval.timer);
            deviceInfoInterval.timer = null;
          }
        }
      })
    })
  },
  getBluetoothReaders({commit}){
    return new Promise((resolve, reject) => {
      getBluetoothReaders().then(response => {
        commit('SET_READERS', response)
        resolve(response);
      })
    })
  },
  getDeviceInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getDeviceInfo().then(response => {
        commit('SET_DEVICE_INFO', response)
      })
    })
  },
  getDeviceInfoInstant({commit}){
    return new Promise((resolve, reject) => {
      getDeviceInfoInstant().then(response => {
        commit('SET_DEVICE_INFO', response)
      })
    })
  },
  disconnectReader({commit, dispatch}){
    return new Promise((resolve, reject) => {
      disconnectZebra().then(response => {
        dispatch('getConnectionStatus').then(status => {
          resolve(status);
        })
      })
    })
  },

  getInventoryStatus({commit, dispatch}){
    return new Promise((resolve, reject) => {
      getInventoryStatus().then(status => {
        commit("SET_INVENTORY_STATE", status);
        if(status){
          commit("SET_TAGS_READ", []);
          if(tagInventoryInterval.timer) return null;

          tagInventoryInterval.timer = setInterval(function(){
            dispatch('readInventoryTags');
          }, tagInventoryInterval.interval);
        } else {
          if(tagInventoryInterval.timer){
            clearInterval(tagInventoryInterval.timer);
            tagInventoryInterval.timer = null;
          }
        }
        resolve(status);
      })
    })
  },
  startInventory({commit, dispatch}, EPCTag){
    return new Promise((resolve, reject) => {
      startInventory().then(() => {
        dispatch('getInventoryStatus').then(status => {
          resolve(status);
        })
      })
    })
  },
  stopInventory({commit, dispatch}){
    return new Promise((resolve, reject) => {
      stopInventory().then(() => {
        dispatch('getInventoryStatus').then(status => {
          resolve(status);
        })
      })
    })
  },
  readInventoryTags({commit, dispatch}){
    return new Promise((resolve, reject) => {
      getTagData().then(tags => {
        commit("SET_TAGS_READ", tags);
      })
    })
  },



  getTagLocateStatus({commit, dispatch}){
    return new Promise((resolve, reject) => {
      getTagLocateStatus().then(status => {
        commit("SET_TAG_LOCATE_STATE", status);
        if(status){
          if(tagLocatePercentageInterval.timer) return null;

          tagLocatePercentageInterval.timer = setInterval(function(){
            dispatch('getTagLocatePercentage');
          }, tagLocatePercentageInterval.interval);
        } else {
          if(tagLocatePercentageInterval.timer){
            clearInterval(tagLocatePercentageInterval.timer);
            tagLocatePercentageInterval.timer = null;
            commit("SET_PERCENTAGE_LOCATE", 0);
          }
        }
        resolve(status);
      })
    })
  },
  startTagLocate({commit, dispatch}, EPCTag){
    return new Promise((resolve, reject) => {
      startTagLocate(EPCTag).then(() => {
        dispatch('getTagLocateStatus').then(status => {
          resolve(status);
        })
      })
    })
  },
  stopTagLocate({commit, dispatch}){
    return new Promise((resolve, reject) => {
      stopTagLocate().then(() => {
        dispatch('getTagLocateStatus').then(status => {
          resolve(status);
        })
      })
    })
  },
  getTagLocatePercentage({commit}){
    return new Promise((resolve, reject) => {
      getTagLocatePercentage().then(percentage => {
        commit("SET_PERCENTAGE_LOCATE", percentage);

        resolve(percentage);
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}